export class Label {
  key: string;
  errorCode: string;
  module: string;
  view: string;
  label: string;
  description: string;
}
